import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {apiRequest, apiPost, apiDelete} from "../../utils/request";
import {toastr} from 'react-redux-toastr';
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import {join, values} from 'lodash';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import TextBoxControl from '../common/TextBoxControl';
import CheckBoxControl from '../common/CheckBoxControl';
import {
    ROLE_Administrator,
    IsStringValid,
    validationCreator,
    EmailRegex,
    ROLE_CustomerAdmin_Id,
    ROLE_Administrator_Id,
    ROLE_CustomerAdmin,
    ROLE_GroupAdmin,
    ROLE_GroupAdmin_Id,
    ROLE_Fabric_Id,
    ROLE_Fabric,
    ROLE_PC,
    ROLE_PC_Id,
    ROLE_OrderFAA,
    ROLE_OrderFAA_Id,
    IsNullOrUndefined,
    PhoneRegex, ORGANISATION_GROUP_ID_NOLANS
} from '../../constants';
import {loadTheme} from "../../actions/themeActions";
import {setCookie} from "../../actions/identityActions";
import store from "../../store";

export const UserValidationRules = {
  roles: {
    validator: (val, state, props) => {
      return val === null || val.length === 0 ? validationCreator(false, 'Please select a role') : validationCreator();
    }
  },
  contactNumber: {
    validator: (val, state, props) => {
      if(val==='' || !val){
        return validationCreator();
      }
      return !IsStringValid(val, PhoneRegex) ? validationCreator(false, 'Please enter a valid phone number') : validationCreator();
    }
  },
  /*jobTitle: {
    validator: (val, state, props) => {
      return !IsStringValid(val) ? validationCreator(false, 'Please enter a valid job title') : validationCreator();
    }
  },*/
  firstName: {
    validator: (val, state, props) => {
      return !IsStringValid(val) ? validationCreator(false, 'Please enter a first name') : validationCreator();
    }
  },
  lastName: {
    validator: (val, state, props) => {
      return !IsStringValid(val) ? validationCreator(false, 'Please enter a last name') : validationCreator();
    }
  },
  userName: {
    validator: (val, state, props) => {
      return !IsStringValid(val, EmailRegex) ? validationCreator(false, 'Please enter a valid email') : validationCreator();
    }
  }
};

const emptyUser = {
  organisation: {
    id: 0,
  },
  firstName: '',
  lastName: '',
  userName: '',
  id: -1,
  personId: -1,
  roles: [{id: 6, description: 'Place Order'}],
  fixedOrderId: null,
  accountMessages: [],
  contactNumber: '',
  jobTitle: '',
  distributorName: '',
  isActive: true,
  canDelete: true,
  sendOrderUpdates: true,
};

class CustomerUsersPage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      users: [],
      userColumns: [],
      selectedUser: null,
      editModalOpen: false,
      validationMessages: {},
    };

    this.loadData = this.loadData.bind(this);
    this.setColumns = this.setColumns.bind(this);
    this.selectEditUser = this.selectEditUser.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.saveUser = this.saveUser.bind(this);
    this.cancelSelectUser = this.cancelSelectUser.bind(this);
    this.handleNewUser = this.handleNewUser.bind(this);
    this.validate = this.validate.bind(this);
    this.deleteUser = this.deleteUser.bind(this);
    this.handleResetPassword = this.handleResetPassword.bind(this);
    this.handleInvite = this.handleInvite.bind(this);
    this.getAvailableRoles = this.getAvailableRoles.bind(this);
    this.handleImpersonate = this.handleImpersonate.bind(this);
  }

  validate(){
    let {selectedUser} = this.state;
    let messages = {};
    let isValid = true;

    if(!selectedUser){
      this.setState({validationMessages: messages});
      return isValid;
    }

    let runValidator = (rules) => {
      for (let propName in rules) {

        let rule = rules[propName];
        let val = selectedUser[propName];

        let valResult = rule.validator(val, this.state, this.props);
        if (!valResult.isValid) {
          messages[propName] = valResult.message;
          isValid = false;
        }
      }
    };

    runValidator(UserValidationRules);

    this.setState({validationMessages: messages});

    return isValid;
  }

  handleResetPassword(row){
    //eslint-disable-next-line
    if(confirm(`Are you sure you'd like to reset this users password?`)) {
      apiPost(`/api/users/reset?userName=${encodeURIComponent(row.userName)}`)
        .then(x => {
          if (x.data && x.data.ok) {
            toastr.success(`Password reset, an email has been sent to ${row.userName}`);
          } else {
            toastr.error(`Unable to reset: ${x.data}`);
          }
        });
    }
  }

  handleInvite(row){
    //eslint-disable-next-line
    if(confirm(`Are you sure you'd like to invite this user?`)) {
      apiPost(`/api/users/invite?userName=${encodeURIComponent(row.userName)}`)
        .then(x => {
          if (x.data && x.data.ok) {
            toastr.success(`Invite sent to ${row.userName}`);
          } else {
            toastr.error(`Unable to reset: ${x.data}`);
          }
        });
    }
  }

  handleImpersonate(row) {
    //eslint-disable-next-line
    if(confirm('Are you sure you want to impersonate this user?')) {
      apiPost(`/api/users/tokenForImpersonation?userId=${row.id}`)
          .then(x => {
            if (x.data) {
              toastr.info('Logging in...');
              this.props.dispatch(loadTheme(row.organisation.organisationGroupId));
              setCookie(x.data, store.dispatch, ()=> {
                toastr.success(`Logged in as ${row.userName}`);
                this.props.history.push('/');
              });
            } else {
              toastr.error(`Unable to impersonate`);
            }
          });
    }
  }

  handleNewUser(){
    let user = {
      ...emptyUser,
      organisation: {
        id: this.props.organisationId,
      },
      roles: [...emptyUser.roles],
      accountMessages: [],
    };

    this.setState({selectedUser: user, editModalOpen: true}, this.validate);
  }

  selectEditUser(user){
    this.setState({selectedUser: {...user}, editModalOpen: true}, this.validate);
  }

  cancelSelectUser(){
    this.setState({selectedUser: null, editModalOpen: false, validationMessages: {}});
  }

  saveUser() {
    if(!this.validate()){
      return;
    }

    let user = {...this.state.selectedUser};

    apiPost('/api/users', user)
      .then(x => {
        if (x.data && x.data.id > 0) {
          toastr.success('Saved user');
          this.setState({selectedUser: null, editModalOpen: false, validationMessages: {}}, this.loadData);
        }
      });
  }

  deleteUser(user){
    // eslint-disable-next-line no-restricted-globals
    if(confirm(`Are you sure you'd like to delete this user?`)) {
      apiDelete(`/api/users`, user)
        .then(x => {
          if(x.data.ok===true && x.data.unableToDelete===true) {
            toastr.warning('User associated with orders, user has been disabled');
          } else if(x.data.ok===true) {
            toastr.success('Deleted user');
          }
          this.loadData();
        });
    }
  }

  handleFieldChange(e, name){
    let {value, type, checked} = e.target;
    let user = {...this.state.selectedUser};

    if(name === 'role'){
      let roles = [];
      for (let i = 0; i < e.target.selectedOptions.length; i++){
        roles.push({id: e.target.selectedOptions[i].value, description: e.target.selectedOptions[i].innerText})
      }
      user.roles = roles;
    }

    else if(type === 'checkbox'){
      user[name] = checked;
    }
    else {
      user[name] = value;
    }
    this.setState({selectedUser: user}, this.validate);
  }

  componentDidUpdate(prevProps){
    if(this.props.organisationId !== prevProps.organisationId && this.props.organisationId !== 0){
      this.loadData();
    }
  }

  getAvailableRoles(){
    let {user} = this.props;
    let isAdmin = user.isInRole(ROLE_Administrator);
    let isFabricMaker = !IsNullOrUndefined(user.organisation.fabricMakerId);
    let isPCer = !IsNullOrUndefined(user.organisation.powderCoaterId);
    const isNolans = user && user.organisation && user.organisation.organisationGroupId === ORGANISATION_GROUP_ID_NOLANS;

    return [
        (isAdmin) ? {value: ROLE_GroupAdmin_Id, label: ROLE_GroupAdmin} : null,
        {value: ROLE_CustomerAdmin_Id, label: ROLE_CustomerAdmin},
      {value: 6, label: 'Place Order'},
      {value: ROLE_OrderFAA_Id, label: ROLE_OrderFAA},
      isAdmin ? {value: 2, label: 'Product Manager'} : null,
      {value: 5, label: 'Quote Only'},
      {value: 7, label: 'Technical Only'},
        ((isAdmin || isFabricMaker) && !isNolans) ? {value: ROLE_Fabric_Id, label: ROLE_Fabric} : null,
        ((isAdmin || isPCer) && !isNolans) ? {value: ROLE_PC_Id, label: ROLE_PC} : null,
    ].filter(x => x !== null);
  }

  setColumns() {
    let {user} = this.props;

    this.setState({
      userColumns: [
        {
          id: 'roles',
          Header: 'Role',
          accessor: c => join(c.roles.map(x => x.description), ', '),
          maxWidth: 150,
        },
        {
          Header: 'User name',
          accessor: 'userName',
        }, {
          Header: 'First Name',
          accessor: 'firstName',
        }, {
          Header: 'Last Name',
          accessor: 'lastName',
        }, {
          Header: 'Phone',
          accessor: 'contactNumber',
          maxWidth: 120,
        }, {
          Header: 'Job Title',
          accessor: 'jobTitle',
          maxWidth: 130,
        }, {
          Header: 'Distributor Name',
          accessor: 'distributorName',
          maxWidth: 160,
        }, {
          Header: 'Is Active',
          accessor: 'isActive',
          Cell: row => <div style={{textAlign: 'center'}}>
            <span>{row.value ? <i className={'fa fa-check'} /> : <i className={'fa fa-times'} />}</span></div>,
          maxWidth: 80,
        }, {
          Header: 'Email Updates',
          accessor: 'sendOrderUpdates',
          Cell: row => <div style={{textAlign: 'center'}}>
            <span>{row.value ? <i className={'fa fa-check'} /> : <i className={'fa fa-times'} />}</span></div>,
          maxWidth: 110,
        },
        {
          id: 'actions',
          Header: '',
          Cell: row => {
            let isAdmin = user.isInRole(ROLE_Administrator);
            let canInvite =  row.original.roles.findIndex(x => x.id === ROLE_CustomerAdmin_Id) >= 0 && (isAdmin || user.isInRole(ROLE_GroupAdmin));
            let canResetEdit =  (row.original.roles.findIndex(x => x.id === ROLE_Administrator_Id) >= 0 && isAdmin) ||
              (row.original.roles.findIndex(x => x.id === ROLE_Administrator_Id) < 0);
            return (
              <span>
                { canResetEdit && <a style={{color: 'var( --textWhite-color )', cursor: 'pointer'}} title={`Edit ${row.original.userName}`} onClick={(e) => {
                  e.preventDefault();
                  this.selectEditUser(row.original);
                }}>
                  <i className="fa fa-edit fa-lg" />
                </a> }
                  { canResetEdit && row.original.canDelete && row.original.id !== user.id &&
                    <a style={{color: 'var( --textWhite-color )', cursor: 'pointer', marginLeft: '7px'}} title={`Delete ${row.original.userName}`} onClick={(e) => {
                      e.preventDefault();
                      this.deleteUser(row.original);
                    }}>
                      <i className="fa fa-trash fa-lg" />
                    </a> }
                { canResetEdit && <a style={{color: 'var( --textWhite-color )', cursor: 'pointer', marginLeft: '7px'}} title={`Reset password for ${row.original.userName}`} onClick={(e) => {
                    e.preventDefault();
                    this.handleResetPassword(row.original);
                  }}>
                  <i className="fa fa-refresh fa-lg" />
                </a> }
                { canInvite &&
                  <a style={{color: 'var( --textWhite-color )', cursor: 'pointer', marginLeft: '7px'}} title={`Send invite ${row.original.userName}`} onClick={(e) => {
                    e.preventDefault();
                    this.handleInvite(row.original);
                  }}>
                    <i className="fa fa-envelope fa-lg" />
                </a> }
                    { isAdmin &&
                    <a style={{color: 'var( --textWhite-color )', cursor: 'pointer', marginLeft: '7px'}}  title={`Impersonate ${row.original.userName}`} onClick={(e) => {
                      e.preventDefault();
                      this.handleImpersonate(row.original);
                    }}>
                      <i className="fa fa-user-md fa-lg" />
                    </a> }

              </span>
            );
          },
          maxWidth: 150,
        }
      ]
    });
  }

  loadData(){
    if(this.props.organisationId > 0) {
      toastr.warning('Loading users');
      apiRequest(`/api/users?organisationId=${this.props.organisationId}`)
        .then(x => this.setState({users: x.data}));
    }
  }

  componentDidMount() {
    this.setColumns();
    this.loadData();
  }

  renderEditModal() {
    let {selectedUser, editModalOpen, validationMessages} = this.state;

    if(!selectedUser){
      return null;
    }

    let roles = this.getAvailableRoles();
    let rolesValid = validationMessages['roles'] === undefined;

    return (
      <Modal isOpen={editModalOpen} toggle={this.cancelSelectUser}>
        <ModalHeader toggle={this.cancelSelectUser}>
          {selectedUser.id > 0 ? `Edit ${selectedUser.userName}` : 'New User'}
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label htmlFor="role">Role</label>
            <select
                id="role"
                name="role"
                className="form-control"
                multiple={true}
                size={roles.length}
                value={selectedUser.roles.map(x => x.id)}
                style={{borderColor: rolesValid ? '' : 'red'}}
                onChange={(e) => this.handleFieldChange(e, 'role')}>
              {roles.map(x =>
                  <option value={x.value} key={`role_${x.value}`}>{x.label}</option>
              )}
            </select>
            { !rolesValid && <div style={{color: 'red'}}>{validationMessages['roles']}</div> }
          </div>

          <TextBoxControl
            labelText="User name"
            name="userName"
            type="email"
            value={selectedUser.userName}
            validationMessages={validationMessages}
            onChange={(e) => this.handleFieldChange(e, 'userName')} />

          <TextBoxControl
            labelText="First Name"
            name="firstName"
            value={selectedUser.firstName}
            validationMessages={validationMessages}
            onChange={(e) => this.handleFieldChange(e, 'firstName')} />

          <TextBoxControl
            labelText="Last Name"
            name="lastName"
            value={selectedUser.lastName}
            validationMessages={validationMessages}
            onChange={(e) => this.handleFieldChange(e, 'lastName')} />

          <TextBoxControl
            labelText="Phone"
            name="contactNumber"
            type="phone"
            value={selectedUser.contactNumber}
            validationMessages={validationMessages}
            onChange={(e) => this.handleFieldChange(e, 'contactNumber')} />

          <TextBoxControl
            labelText="Job Title"
            name="jobTitle"
            value={selectedUser.jobTitle}
            validationMessages={validationMessages}
            onChange={(e) => this.handleFieldChange(e, 'jobTitle')} />

          <TextBoxControl
            labelText="Distributor Name"
            name="distributorName"
            value={selectedUser.distributorName}
            validationMessages={validationMessages}
            onChange={(e) => this.handleFieldChange(e, 'distributorName')} />

          <CheckBoxControl
            labelText="Is Active"
            name="isActive"
            value={selectedUser.isActive}
            onChange={(e) => this.handleFieldChange(e, 'isActive')} />

          <CheckBoxControl
            labelText="Email Updates"
            name="sendOrderUpdates"
            value={selectedUser.sendOrderUpdates}
            onChange={(e) => this.handleFieldChange(e, 'sendOrderUpdates')} />
        </ModalBody>
        <ModalFooter>
          <button
            className="btn pi-btn-base"
            disabled={values(validationMessages).length > 0}
            onClick={this.saveUser}>
            Save
          </button>
          <button className="btn" onClick={this.cancelSelectUser}>
            Cancel
          </button>
        </ModalFooter>
      </Modal>);
  }

  render() {

    let {users, userColumns} = this.state;

    return (
      <div className="pi-section-w pi-section-white">
        <div className="pi-section pi-padding-bottom-10">
          <div className="pi-row pi-grid-big-margins">
            <div className={'pi-col-md-8'}>
              <h2>User Management</h2>
            </div>
            <div className={'pi-col-md-4'} style={{textAlign: 'right'}}>
              <button
                className="btn pi-btn-base pi-btn-icon-big"
                onClick={this.handleNewUser}>
                <i className="fa fa-plus"></i>&nbsp;New User
              </button>
            </div>
          </div>
        </div>

        <ReactTable
          sortable={false}
          filterable={false}
          showPagination={false}
          data={users}
          columns={userColumns}
          defaultPageSize={250}
          minRows={6}
        />

        {this.renderEditModal()}
      </div>);
  }
}

CustomerUsersPage.propTypes = {
  user: PropTypes.object.isRequired,
  organisationId: PropTypes.number.isRequired,
};

function mapStateToProps(state, ownProps) {
  let organisationId = state.user.organisation.id;
  if(ownProps.match && ownProps.match.params && ownProps.match.params.id){
    organisationId = parseInt(ownProps.match.params.id);
  }
  return {
    user: state.user,
    organisationId,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomerUsersPage));
